import type { AppointmentStatus } from '@chat-emp/shared';

/**
 * The word an appointment's state is worth, or nothing.
 *
 * `confirmed` prints nothing. It is the overwhelmingly common state, and a
 * column of rows all reading "Confirmed" is a column of ink reporting that the
 * normal thing happened; the states worth a word are the ones the employer has
 * to act on.
 *
 * `pending` shares `awaiting_approval`'s word rather than getting its own: it is
 * a transient state the employer cannot distinguish or act on differently, and
 * "Pending" beside "Awaiting reply" would be a distinction without one.
 *
 * Words, not coloured dots. One mark cannot say which of three states it means,
 * so it lands as decoration with a colour nobody can cash in — and beside a word
 * it merely repeats it. "Awaiting reply" and "Done" already differ at a glance
 * in shape and length, with no legend.
 */
const LABELS: Record<AppointmentStatus, string | null> = {
  pending: 'Awaiting reply',
  awaiting_approval: 'Awaiting reply',
  confirmed: null,
  reschedule_requested: 'Reschedule asked',
  completed: 'Done',
};

export function statusLabel(status: AppointmentStatus): string | null {
  return LABELS[status] ?? null;
}
